<template>
	<ac-modal :title="''" ref="modal" :size-class="'modal-md'">
		<template>
			<div class="row">
				<div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
					<p>
						You are about to select the <em>{{ planName }}</em>
						plan. By selecting this plan, you are agreeing to the
						specifications and services outlined in the plan description
						on this physician and/or clinic's profile.
					</p>
					<p>
						<em>
							Note: If you previously selected a plan, your new selection
							will not go into effect until the 1st of the following month.
						</em>
					</p>
					<p>Would you like to proceed with selecting this plan?</p>
				</div>
			</div>
		</template>
		<template slot="buttons">
			<ac-button type="button" class="btn btn-red  btn-sm" :action="cancel">
				No, I want to pick a different plan.
			</ac-button>
			<ac-button type="button" class="btn btn-green btn-sm" :action="confirm">
				Yes, I want to pick this plan.
			</ac-button>
		</template>
	</ac-modal>
</template>

<script>
	import {api} from "../../../global/framework/api.js";

	export default {
		name: "PlanConfirmationModal",
		data() {
			return {
				resolveRef: null,
				planName: ""
			}
		},
		async mounted() {
			this.addBusEvents();
		},
		methods: {
			addBusEvents() {
				this.$bus.$on(this.$AcEvents.SHOW_PLAN_CONFIRMATION_POPUP, this.eventListener);
			},
			eventListener({resolve, reject, params}) {
				let self = this;
				//console.log("Showing plan confirmation popup, resolve:", resolve, " reject:", reject, " params:", params);
				api.getDataWithTwoIds("Consumer", params.mainConsumerId, "GetPlanBasicInfo", params.planId).then(
					function (result) {
						self.planName = result.planName;
						self.$refs.modal.open();
					}
				);
				self.resolveRef = resolve;
			},
			cancel() {
				this.$refs.modal.close();
				this.resolveRef(false);
			},
			confirm() {
				this.$refs.modal.close();
				this.resolveRef(true);
			}
		},
		beforeDestroy() {
			this.$bus.$off(this.$AcEvents.SHOW_PLAN_CONFIRMATION_POPUP, this.eventListener);
		}
	}
</script>

<style scoped>

</style>